export default (function (originalString, threshold) {
    if (originalString.length > threshold) {
        return originalString.substring(0, threshold) + '...';
    }
    return originalString;
});
